import { render, staticRenderFns } from "./DmvTitle.vue?vue&type=template&id=5b263432"
import script from "./DmvTitle.vue?vue&type=script&lang=js"
export * from "./DmvTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports